export default __webpack_public_path__ + "static/media/card-project5.a0b513c8.jpg";